var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{staticStyle:{"box-shadow":"none"},attrs:{"open-on-hover":"","offset-y":"","top":"","offset-overflow":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({},on),[_vm._t("activator")],2)]}}],null,true)},[_c('div',{staticClass:"hover-menu"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }